import React, { useState } from 'react';
import '../css/Auth.css';

const Auth = ({ onLogin }) => {
    const [isRegister, setIsRegister] = useState(false); // Состояние: вход или регистрация
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const BASE_URL = process.env.REACT_APP_API_URL || 'https://church.info-roman-b.workers.dev';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // Выбираем эндпоинт в зависимости от режима
        const endpoint = isRegister ? '/register' : '/';
        const payload = isRegister
            ? { login, password, name, lastname }
            : { login, password };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.success) {
                localStorage.setItem('user', JSON.stringify(data.user));
                onLogin(data.user);
            } else {
                setError(data.error || 'Ошибка доступа');
            }
        } catch (err) {
            setError('Ошибка соединения с сервером');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="Auth_container">
            <form className="Auth_form" onSubmit={handleSubmit}>
                <h1>{isRegister ? 'Регистрация' : 'Мир тебе'}</h1>
                {error && <p className="error_msg">{error}</p>}

                {isRegister && (
                    <>
                        <input type="text" placeholder="Имя" value={name} onChange={(e) => setName(e.target.value)} required />
                        <input type="text" placeholder="Фамилия" value={lastname} onChange={(e) => setLastname(e.target.value)} required />
                    </>
                )}

                <input type="text" placeholder="Логин" value={login} onChange={(e) => setLogin(e.target.value)} required />
                <input type="password" placeholder="Пароль" value={password} onChange={(e) => setPassword(e.target.value)} required />

                <button type="submit" disabled={loading}>
                    {loading ? 'Обработка...' : (isRegister ? 'Создать аккаунт' : 'Войти')}
                </button>

                <p className="toggle_auth" onClick={() => {
                    setIsRegister(!isRegister);
                    setError('');
                }}>
                    {isRegister ? 'Уже есть аккаунт? Войти' : 'Нет аккаунта? Зарегистрироваться'}
                </p>
            </form>
        </div>
    );
};

export default Auth;